import AccessControlDialog from "@/components/call/access-controls/shared/dialog";
import { AccessControlSendLostTicket } from "@EspaceParkQC/sdk-call-center";
import { toast } from "@EspaceParkQC/sdk-react";
import { Ticket } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function SendLostTicket() {
  const { t } = useTranslation("main");

  function handleSubmit() {
    toast.loading(t("intercom.access-controls.send-lost-ticket.submitting"));
  }

  function handleSuccess() {
    toast.success(t("intercom.access-controls.send-lost-ticket.success"));
  }

  function handleError(error: unknown) {
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error(JSON.stringify(error));
    }
  }

  return (
    <AccessControlSendLostTicket
      onError={handleError}
      onSuccess={handleSuccess}
      render={({ button, form }) => (
        <AccessControlDialog
          title={t("intercom.access-controls.send-lost-ticket.title")}
          description={t("intercom.access-controls.send-lost-ticket.description")}
          icon={<Ticket className="size-4" />}
          buttonProps={button}
          formProps={form}
          showCostInput
          onSubmit={async () => handleSubmit()}
          formOnSubmit={async (value?: string | number) => {
            if (typeof value === "number") {
              await form.onSubmit(value);
            }
          }}
        />
      )}
    />
  );
}
